import { IconContent } from '@icons';

export const arrowsBordersVertical: IconContent = {
    sm: '<path d="M7.5 3v7.793L5.854 9.146l-.707.708 2.5 2.5.146.146H3v1h10v-1H8.207l.147-.146 2.5-2.5-.707-.708L8.5 10.793V3h-1Z" />',
};
